import React, { useEffect } from 'react';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import RetrievePolicy from 'scenes/payments/components/Steps/RetrievePolicy';
import Confirmation from 'scenes/payments/components/Steps/Confirmation';
import { useSelector } from 'react-redux';
import PolicyPayment from './components/Steps/PolicyPayment';
import PageWrapper from './components/PageWrapper/PageWrapper';
import { SystemErrorPage } from './components/Errors';
import MakePayment from './components/Steps/MakePayment/MakePayment';
import GridWrapper from './components/PageWrapper/GridWrapper';
import { RoutePaths } from './routes';
import { getIsSystemErrorState } from './redux/payment/selectors';
import usePublishAnalyticsEvent, { AnalyticsEvent } from './hooks/useAnalytics';

export default function PaymentFullPage() {
  const { path } = useRouteMatch();
  const inErrorState = useSelector(getIsSystemErrorState);
  const analyticsLoadEvent = usePublishAnalyticsEvent(
    AnalyticsEvent.VIEW_LOADED
  );
  const analyticsLoadErrorEvent = usePublishAnalyticsEvent(
    AnalyticsEvent.VIEW_LOADED_ERROR
  );

  // Send analytics viewloaded event whenever a page loads
  useEffect(() => {
    (inErrorState ? analyticsLoadErrorEvent : analyticsLoadEvent)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href]);

  return (
    <PageWrapper>
      {inErrorState && <Redirect to={RoutePaths.ERROR} />}
      <Switch>
        <Route exact path={path}>
          <GridWrapper md={6} xs={12} offset={3}>
            <RetrievePolicy />
          </GridWrapper>
        </Route>
        <Route exact path={`${path}/retrieve`}>
          <GridWrapper md={12} xs={12} offset={0}>
            <RetrievePolicy />
          </GridWrapper>
        </Route>
        <Route exact path={`${path}/policy`}>
          <GridWrapper md={8} xs={12} offset={2}>
            <PolicyPayment />
          </GridWrapper>
        </Route>
        <Route exact path={`${path}/pay`}>
          <GridWrapper md={6} xs={12} offset={3}>
            <MakePayment />
          </GridWrapper>
        </Route>
        <Route exact path={`${path}/confirm`}>
          <GridWrapper md={6} xs={12} offset={3}>
            <Confirmation />
          </GridWrapper>
        </Route>
        <Route exact path={`${path}/error`}>
          <GridWrapper md={6} xs={12} offset={3}>
            <SystemErrorPage />
          </GridWrapper>
        </Route>
      </Switch>
    </PageWrapper>
  );
}
